import navHomeLevelEffectView from './nav-home-level-effect'
import navHomeXpEffectView from './nav-home-xp-effect'
import navHomeMaxLevelEffectView from './nav-home-max-level-effect'

export default function navHomeEffectView (node, progress) {
  navHomeLevelEffectView(node, progress)
  navHomeXpEffectView(node, progress)
  navHomeMaxLevelEffectView(node, progress)
}
